<template>
  <v-autocomplete
    v-model="ITENS_SELECIONADOS"
    :items="itens_autocomplete"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    append-icon=""
    :disabled="disabled"
    :loading="carregando_dados"
    @change="evChange"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        color="red"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #append v-if="!ocultar_cadastro">
      <CadastroDeSysCategoriaProdutos
        class="z-999"
        :disabled="disabled"
        :categorias_pai="categorias_pai"
        @update:grupos_produtos="buscarItensAutocomplete"
      />
    </template>

    <template #prepend-item v-if="SELECAO_MULTIPLA_ATIVADA && itens_autocomplete.length">
      <v-list-item
        v-if="ITENS_SELECIONADOS.length === itens_autocomplete.length"
        class="pl-14px py-2"
        @click="ITENS_SELECIONADOS = []"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todas</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="ITENS_SELECIONADOS = Helpers.arrayColumn(itens_autocomplete, 'id')"
      >
        <v-icon v-if="ITENS_SELECIONADOS.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todas</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="SELECAO_MULTIPLA_ATIVADA">
      <template v-if="ITENS_SELECIONADOS.indexOf(item.id) < qtde_visivel_selecionados">
        {{item.descricao }}<template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="ITENS_SELECIONADOS.indexOf(item.id) === qtde_visivel_selecionados">
        <span class="ml-1 text-gray-100">(+ {{ITENS_SELECIONADOS.length - qtde_visivel_selecionados}})</span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import {computed, onMounted, ref, watch} from "vue";
import {buscarSysCategorias} from "@/api/SysCategorias";
import {logout} from "@/helpers";
import CadastroDeSysCategoriaProdutos from "@/components/SysCategorias/CadastroDeSysCategoriaProdutos";

export default {
  name: "SysCategoriasAutocomplete",
  components: {
    CadastroDeSysCategoriaProdutos
  },
  emits: ['update:modelValue', 'change'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: [String, Array],
    disabled: Boolean,
    categorias_pai: {
      type: Array,
      default: () => ([])
    },
    qtde_visivel_selecionados: {
      type: Number,
      default: 1
    },
    ocultar_cadastro: Boolean
  },
  setup(props, ctx) {
    let carregando_dados = ref(false);
    let itens_autocomplete = ref([]);

    let ITENS_SELECIONADOS = computed({
      get: () => props.modelValue,
      set: valor => ctx.emit('update:modelValue', valor),
    });


    const buscarItensAutocomplete = () => {
      if (props.disabled) return;

      carregando_dados.value = true;
      ITENS_SELECIONADOS = '';

      const parametros = {
        categorias_pai: props.categorias_pai,
      };

      buscarSysCategorias(parametros)
        .then(itens => {
          itens_autocomplete.value = itens;
          carregando_dados.value = false;
        })
        .catch(logout);
    };

    onMounted(buscarItensAutocomplete);

    let timer_buscar_itens = null;
    const buscarItensAutocompleteAposTimer = () => {
      clearTimeout(timer_buscar_itens);
      timer_buscar_itens = setTimeout(buscarItensAutocomplete, 2000);
    };

    watch(() => props.disabled, buscarItensAutocompleteAposTimer);
    watch(() => props.categorias_pai.length, buscarItensAutocompleteAposTimer);

    const evChange = ev => ctx.emit('change', ev);

    const SELECAO_MULTIPLA_ATIVADA = computed(() => ![undefined, null, false].includes(ctx.attrs.multiple));

    const apendarVirgula = item => {
      const indexOf = ITENS_SELECIONADOS.indexOf(item.id)
      return indexOf !== ITENS_SELECIONADOS.length - 1 && indexOf < (props.qtde_visivel_selecionados - 1)
    }

    return {
      ITENS_SELECIONADOS,
      itens_autocomplete,
      buscarItensAutocomplete,
      evChange,
      carregando_dados,
      SELECAO_MULTIPLA_ATIVADA,
      apendarVirgula
    }
  }
}
</script>

<style scoped>

</style>
